import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'

import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

import DropDown from '@components/dropdown/v2'

import { PrecinctListItemInterface, StageInterface } from '@api/houseAndLand'

import FirebaseControlQuery from '@firebaseUtil/firebase-control-query'

interface PrecinctDropdownProps {
  projectIdentity: ProjectIdentity
  activePrecinct: string
  precinctList: Array<PrecinctListItemInterface>
  stages: Array<StageInterface>
}

function PrecinctDropdown({
  precinctList,
  activePrecinct,
  projectIdentity,
  stages,
}: PrecinctDropdownProps) {
  const firebaseControlQuery = FirebaseControlQuery({
    ...projectIdentity,
    sessionKey: projectIdentity.sessionId,
  })
  const [isPrecinctChange, setPrecinctChange] = useState(false)

  const precinctOptions = useMemo(
    () =>
      precinctList.map(({ label }) => ({
        label,
        value: label,
      })),
    [precinctList]
  )

  const onChange = useCallback(
    async (value: string) => {
      await firebaseControlQuery.update({
        [`houseAndLand.activePrecinctId`]: value,
        [`houseAndLand.activeLotId`]: '',
      })
      setPrecinctChange(true)
    },
    [firebaseControlQuery]
  )

  useEffect(() => {
    if (isPrecinctChange) {
      const firstStage = stages[0]?.label

      if (!firstStage) return

      firebaseControlQuery.update({
        [`houseAndLand.activeStageId`]: firstStage,
      })

      setPrecinctChange(false)
    }
  }, [stages, isPrecinctChange])

  if (precinctOptions.length <= 1) return null

  return (
    <DropDown
      onSelect={onChange}
      items={precinctOptions}
      value={activePrecinct || precinctOptions[0].value}
      className="py-2"
      buttonRadius="rounded-[7px]"
      buttonRadiusClasses="rounded-tl-[7px] rounded-tr-[7px]"
      optionRadiusClasses="rounded-bl-[7px] rounded-br-[7px]"
    />
  )
}

export default connect(
  ({
    projectIdentity,
    firestore: { session },
    houseAndLand: { precinctList },
  }: RootStateTypeExtra) => ({
    projectIdentity,
    precinctList,
    activePrecinct: session?.houseAndLand?.activePrecinctId || '',
  })
)(PrecinctDropdown)
